export default __webpack_public_path__ + "static/media/tramitacion.80c02ea0.svg";